import React, { ReactNode, useState, useEffect } from 'react';
import styled from 'astroturf/react';
import { WhiteCheckIcon, InfoIcon } from 'js/social/shared/Icons';
import _SnackBarContainer from "SnackBar-SnackBarContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SnackBar.tsx?styleId=SnackBarContainer";
import _SnackBarText from "SnackBar-SnackBarText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SnackBar.tsx?styleId=SnackBarText";


export interface SnackbarProps {
  /** Message to be displayed in the snackbar */
  message: ReactNode;
  /** Type of snackbar to be displayed, default is 'info' */
  type?: 'success' | 'warning' | 'failure' | 'info';
  /** If provided, the snackbar becomes a clickable button */
  onClick?: () => void;
  /** Duration in milliseconds for the snackbar to be displayed, default is 3000 */
  durationInMs?: number;
  /** Whether to show an icon at the beginning of the message (if applicable), default is true */
  showIcon?: boolean;
}

const SnackBarContainer = /*#__PURE__*/styled(({
  onClick,
  children,
  ...props
}) => onClick ? <button onClick={onClick} {...props}>
      {children}
    </button> : <div {...props}>{children}</div>, null, {
  displayName: "SnackBarContainer",
  styles: _SnackBarContainer
});

const SnackBarText = /*#__PURE__*/styled("div", null, {
  displayName: "SnackBarText",
  styles: _SnackBarText
});

const SnackBar = ({
  message,
  type = 'info',
  onClick = undefined,
  durationInMs = 3000,
  showIcon = true,
}: SnackbarProps) => {
  const [open, setOpen] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(false);
    }, durationInMs);
    return () => {
      clearTimeout(timer);
    };
  }, [durationInMs]);

  const getColors = (type: SnackbarProps['type']) => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: '#F0F8F1',
          borderColor: '#048C16',
          textColor: '#035C0F',
          icon: <WhiteCheckIcon style={{ marginRight: '6px' }} />,
        };
      case 'warning':
        return {
          backgroundColor: '#F9F6ED',
          borderColor: '#B08920',
          textColor: '#222233',
        };
      case 'failure':
        return {
          backgroundColor: '#FBF0F0',
          borderColor: '#B60000',
          textColor: '#222233',
        };
      default:
        return {
          backgroundColor: '#F4F7FC',
          borderColor: '#0057EB',
          textColor: '#0645B1',
          icon: <InfoIcon style={{ marginRight: '6px' }} />,
        };
    }
  };

  const { backgroundColor, borderColor, textColor, icon } = getColors(type);

  return (
    <div>
      {open && (
        <SnackBarContainer
          style={{
            backgroundColor: backgroundColor,
            border: `1px solid ${borderColor}`,
            color: textColor,
          }}
          onClick={onClick}
        >
          <SnackBarText>
            {showIcon && icon}
            {message}
          </SnackBarText>
        </SnackBarContainer>
      )}
    </div>
  );
};

export default SnackBar;
